// import React, { useState, useEffect } from 'react';
// import * as XLSX from 'xlsx';
// import { message } from "antd";

// import {
//   Row,
//   Col,
//   Card,
//   Table,
//   Input,
//   Button,
//   Modal,
//   Tag,
//   Space,
//   Typography,
//   Tooltip,
//   Avatar,
//   Badge,
//   Segmented,
//   Empty,
//   Descriptions,
//   Grid,
//   Collapse,
//   Pagination
// } from 'antd';

// import {
//   SearchOutlined,
//   DownloadOutlined,
//   EyeOutlined,
//   PrinterOutlined,
//   DashboardOutlined,
//   CarOutlined,
//   WalletOutlined,
//   FileTextOutlined,
//   CheckCircleOutlined,
//   CalendarOutlined,
//   TruckOutlined,
//   RiseOutlined,
//   ReconciliationOutlined,
//   ArrowUpOutlined,
//   RightOutlined
// } from '@ant-design/icons';
// import { motion } from "framer-motion";
// import logo from '../Logo.png'
// // Import services from Services
// import { getPendingBills, getReceipts, getDashboardData } from '../Services/Services';

// const { Text, Title } = Typography;
// const { useBreakpoint } = Grid;
// const { Panel } = Collapse;

// const DashboardContent = () => {
//   const screens = useBreakpoint();
//   const isMobile = !screens.md; // mobile view for screens < 992px? adjust as needed. Use xs or sm.
//   // Better: isMobile = screens.xs === true (extra small)
//   const isExtraSmall = screens.xs;

//   const [stats, setStats] = useState({
//     totalBills: 0,
//     totalReceipts: 0,
//     pendingAmount: 0,
//     collectionRate: 0,
//     totalVehicles: 0,
//     totalTransactions: 0,
//     loading: true
//   });

//   const [searchTerm, setSearchTerm] = useState('');
//   const [modal, setModal] = useState(null);
//   const [activeView, setActiveView] = useState('last5');
//   const [selectedTransaction, setSelectedTransaction] = useState(null);
//   const [allBills, setAllBills] = useState([]);
//   const [allReceipts, setAllReceipts] = useState([]);
//   const [mobilePage, setMobilePage] = useState(1);
//   const mobilePageSize = 5;

//   // Helper function to get vehicle number from bill
//   const getVehicleNo = (bill) => {
//     if (bill.vehicle_no) return bill.vehicle_no;
//     if (bill.items && bill.items.length > 0 && bill.items[0].vehicle_no) {
//       return bill.items[0].vehicle_no;
//     }
//     return 'N/A';
//   };

//   // Helper function to get mobile number from bill
//   const getMobileNo = (bill) => {
//     if (bill.mobile_no) return bill.mobile_no;
//     if (bill.items && bill.items.length > 0 && bill.items[0].mobile) {
//       return bill.items[0].mobile;
//     }
//     return 'N/A';
//   };

//   // Helper function to get description from bill
//   const getDescription = (bill) => {
//     if (bill.description) return bill.description;
//     if (bill.items && bill.items.length > 0) {
//       return bill.items.map(item => item.description).filter(Boolean).join(', ');
//     }
//     return '';
//   };

//   const fetchDashboardData = async () => {
//     try {
//       // Fetch dashboard summary data
//       const dashboardData = await getDashboardData();

//       // Fetch bills and receipts for transaction details
//       const [billsData, receiptsData] = await Promise.all([
//         getPendingBills(),
//         getReceipts()
//       ]);

//       // Extract the data array from the response structure
//       const bills = billsData?.data || billsData?.results || billsData || [];
//       const receipts = receiptsData?.data || receiptsData?.results || receiptsData || [];

//       const billsMapped = bills.map(b => ({
//         ...b,
//         type: 'Bill',
//         amt: Number(b.total_amount || 0),
//         ref_no: b.bill_id || b.id,
//         party: b.party_name || 'General',
//         date: b.bill_date,
//         vehicle_no: getVehicleNo(b),
//         mobile_no: getMobileNo(b),
//         description: getDescription(b),
//         timestamp: new Date(b.bill_date).getTime()
//       }));

//       const receiptsMapped = receipts.map(r => ({
//         ...r,
//         type: 'Receipt',
//         amt: Number(r.amount || 0),
//         ref_no: r.receipt_no || r.id,
//         party: r.received_from || 'General',
//         date: r.receipt_date,
//         vehicle_no: r.vehicle_no || 'N/A',
//         description: r.description || '',
//         mobile_no: r.mobile_no || 'N/A',
//         timestamp: new Date(r.receipt_date).getTime()
//       }));

//       // Sort bills and receipts by date (newest first)
//       const sortedBills = billsMapped.sort((a, b) => new Date(b.date) - new Date(a.date));
//       const sortedReceipts = receiptsMapped.sort((a, b) => new Date(b.date) - new Date(a.date));

//       setAllBills(sortedBills);
//       setAllReceipts(sortedReceipts);

//       // Calculate summary stats
//       const totalBills = bills.length;
//       const totalReceipts = receipts.length;
//       const totalPendingAmount = bills.reduce((sum, b) => sum + Number(b.total_amount || 0), 0);
//       const uniqueVehicles = new Set();
//       bills.forEach(b => {
//         const vehicle = getVehicleNo(b);
//         if (vehicle !== 'N/A') uniqueVehicles.add(vehicle);
//       });
//       receipts.forEach(r => {
//         if (r.vehicle_no && r.vehicle_no !== 'N/A') uniqueVehicles.add(r.vehicle_no);
//       });

//       // Use dashboard data for stats if available, otherwise calculate from fetched data
//       setStats({
//         totalBills: dashboardData?.total_bills || totalBills,
//         totalReceipts: dashboardData?.total_receipts || totalReceipts,
//         pendingAmount: dashboardData?.pending_amount || totalPendingAmount,
//         collectionRate: dashboardData?.collection_rate || 0,
//         totalVehicles: dashboardData?.total_vehicles || uniqueVehicles.size,
//         totalTransactions: dashboardData?.transactions || (bills.length + receipts.length),
//         loading: false
//       });

//     } catch (err) {
//       console.error('Error fetching dashboard data:', err);
//       message.error('Failed to fetch dashboard data');
//       setStats(prev => ({ ...prev, loading: false }));
//     }
//   };

//   useEffect(() => {
//     fetchDashboardData();
//     // Refresh data every 30 seconds
//     const interval = setInterval(fetchDashboardData, 30000);
//     return () => clearInterval(interval);
//   }, []);

//   // Get grouped data for desktop table view
//   const getDisplayData = () => {
//     if (activeView === 'last5') {
//       // Combine all transactions, sort by date, take last 5
//       const allTransactions = [...allBills, ...allReceipts];
//       const sortedAll = allTransactions.sort((a, b) => new Date(b.date) - new Date(a.date));
//       const last5 = sortedAll.slice(0, 5);

//       // Group by party for display
//       const grouped = last5.reduce((acc, item) => {
//         if (!acc[item.party]) acc[item.party] = [];
//         acc[item.party].push(item);
//         return acc;
//       }, {});
//       return grouped;
//     }
//     else if (activeView === 'bills') {
//       // Show all bills
//       let filteredBills = [...allBills];
//       if (searchTerm) {
//         filteredBills = filteredBills.filter(t =>
//           t.party.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           t.ref_no?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
//           t.vehicle_no?.toLowerCase().includes(searchTerm.toLowerCase())
//         );
//       }
//       const grouped = filteredBills.reduce((acc, item) => {
//         if (!acc[item.party]) acc[item.party] = [];
//         acc[item.party].push(item);
//         return acc;
//       }, {});
//       return grouped;
//     }
//     else if (activeView === 'receipts') {
//       // Show last 5 receipts only
//       const last5Receipts = allReceipts.slice(0, 5);
//       let filteredReceipts = [...last5Receipts];
//       if (searchTerm) {
//         filteredReceipts = filteredReceipts.filter(t =>
//           t.party.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           t.ref_no?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
//           t.vehicle_no?.toLowerCase().includes(searchTerm.toLowerCase())
//         );
//       }
//       const grouped = filteredReceipts.reduce((acc, item) => {
//         if (!acc[item.party]) acc[item.party] = [];
//         acc[item.party].push(item);
//         return acc;
//       }, {});
//       return grouped;
//     }
//     return {};
//   };

//   // Get flattened transactions for mobile view
//   const getMobileTransactions = () => {
//     let transactions = [];
//     if (activeView === 'last5') {
//       const allTransactions = [...allBills, ...allReceipts];
//       transactions = allTransactions.sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 5);
//     } else if (activeView === 'bills') {
//       transactions = [...allBills];
//       if (searchTerm) {
//         transactions = transactions.filter(t =>
//           t.party.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           t.ref_no?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
//           t.vehicle_no?.toLowerCase().includes(searchTerm.toLowerCase())
//         );
//       }
//       // sort newest first
//       transactions.sort((a, b) => new Date(b.date) - new Date(a.date));
//     } else if (activeView === 'receipts') {
//       transactions = allReceipts.slice(0, 5);
//       if (searchTerm) {
//         transactions = transactions.filter(t =>
//           t.party.toLowerCase().includes(searchTerm.toLowerCase()) ||
//           t.ref_no?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
//           t.vehicle_no?.toLowerCase().includes(searchTerm.toLowerCase())
//         );
//       }
//       // sort newest first
//       transactions.sort((a, b) => new Date(b.date) - new Date(a.date));
//     }
//     return transactions;
//   };

//   const filteredData = getDisplayData();
//   const mobileTransactions = getMobileTransactions();

//   // Pagination for mobile bills view
//   const paginatedMobileTransactions = activeView === 'bills' 
//     ? mobileTransactions.slice((mobilePage - 1) * mobilePageSize, mobilePage * mobilePageSize)
//     : mobileTransactions;

//   const handleMobilePageChange = (page) => {
//     setMobilePage(page);
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const exportExcel = () => {
//     // Prepare summary data
//     const totalBillsAmount = allBills.reduce((sum, item) => sum + item.amt, 0);
//     const totalReceiptsAmount = allReceipts.reduce((sum, item) => sum + item.amt, 0);
//     const last5Transactions = [...allBills, ...allReceipts]
//       .sort((a, b) => new Date(b.date) - new Date(a.date))
//       .slice(0, 5);

//     const summaryData = [{
//       'Report Generated On': new Date().toLocaleString(),
//       'Generated By': 'DK RTO AND INSURANCE ADVISOR',
//       'Total Bills': stats.totalBills,
//       'Total Bills Amount (₹)': totalBillsAmount.toLocaleString('en-IN'),
//       'Total Receipts': stats.totalReceipts,
//       'Total Receipts Amount (₹)': totalReceiptsAmount.toLocaleString('en-IN'),
//       'Pending Amount (₹)': stats.pendingAmount.toLocaleString('en-IN'),
//       'Collection Rate (%)': (stats.collectionRate * 100).toFixed(2),
//       'Total Vehicles': stats.totalVehicles,
//       'Total Transactions': allBills.length + allReceipts.length
//     }];

//     // Prepare all bills data
//     const allBillsData = allBills.map((item, index) => ({
//       'S.No': index + 1,
//       'Party Name': item.party,
//       'Bill No': item.ref_no,
//       'Amount (₹)': item.amt.toLocaleString('en-IN'),
//       'Bill Date': item.date ? new Date(item.date).toLocaleDateString('en-IN') : 'N/A',
//       'Mobile No': item.mobile_no || 'N/A',
//       'Description': item.description || ''
//     }));

//     // Prepare all receipts data (full list)
//     const allReceiptsData = allReceipts.map((item, index) => ({
//       'S.No': index + 1,
//       'Party Name': item.party,
//       'Receipt No': item.ref_no,
//       'Amount (₹)': item.amt.toLocaleString('en-IN'),
//       'Receipt Date': item.date ? new Date(item.date).toLocaleDateString('en-IN') : 'N/A',
//       'Mobile No': item.mobile_no || 'N/A',
//       'Description': item.description || ''
//     }));

//     // Prepare last 5 transactions data
//     const last5Data = last5Transactions.map((item, index) => ({
//       'S.No': index + 1,
//       'Party Name': item.party,
//       'Reference No': item.ref_no,
//       'Type': item.type,
//       'Amount (₹)': item.amt.toLocaleString('en-IN'),
//       'Date': item.date ? new Date(item.date).toLocaleDateString('en-IN') : 'N/A',
//       'Mobile No': item.mobile_no || 'N/A',
//       'Description': item.description || ''
//     }));

//     // Create workbook
//     const wb = XLSX.utils.book_new();

//     // Helper to add sheet with auto column width
//     const addSheetWithAutoWidth = (data, sheetName) => {
//       const ws = XLSX.utils.json_to_sheet(data);

//       // Auto-set column widths
//       const colWidths = [];
//       if (data.length > 0) {
//         Object.keys(data[0]).forEach((key, idx) => {
//           let maxLength = key.length;
//           data.forEach(row => {
//             const value = row[key]?.toString() || '';
//             maxLength = Math.max(maxLength, value.length);
//           });
//           colWidths[idx] = { wch: Math.min(maxLength + 2, 40) };
//         });
//       }
//       ws['!cols'] = colWidths;

//       XLSX.utils.book_append_sheet(wb, ws, sheetName);
//     };

//     // Add all sheets
//     addSheetWithAutoWidth(summaryData, '📊 Summary');
//     addSheetWithAutoWidth(last5Data, '📋 Last 5 Transactions');
//     addSheetWithAutoWidth(allBillsData, '💰 All Bills');
//     addSheetWithAutoWidth(allReceiptsData, '✅ All Receipts');

//     // Save file
//     const fileName = `RTO_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
//     XLSX.writeFile(wb, fileName);

//     message.success({
//       content: 'Excel report exported successfully!',
//       duration: 3
//     });
//   };

//   // Print format (unchanged, fully functional)
//   const handlePrint = (item) => {
//     const printWindow = window.open('', '_blank');
//     const currentDate = new Date();
//     const formattedDate = currentDate.toLocaleDateString('en-IN', {
//       day: '2-digit',
//       month: '2-digit',
//       year: 'numeric'
//     });

//     // Helper function to format currency
//     const formatCurrency = (amount) => {
//       if (isNaN(amount)) return '0.00';
//       return parseFloat(amount).toLocaleString('en-IN', {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2
//       });
//     };

//     const isBill = item.type === 'Bill';
//     const titleText = isBill ? 'SERVICE BILL / VOUCHER' : 'PAYMENT RECEIPT';
//     const refLabel = isBill ? 'Bill No' : 'Receipt No';

//     // Build items rows HTML
//     let itemsRows = '';
//     if (isBill && item.items && item.items.length > 0) {
//       item.items.forEach((itm, idx) => {
//         itemsRows += `
//         <tr style="border-bottom: 1px solid #e2e8f0;">
//           <td style="padding: 8px; text-align: center;">${idx + 1}</td>
//           <td style="padding: 8px;"><strong>${itm.vehicle_no || '-'}</strong></td>
//           <td style="padding: 8px;">${itm.description || '-'}</td>
//           <td style="padding: 8px; text-align: center;">${itm.service_date || item.date || '-'}</td>
//           <td style="padding: 8px; text-align: right; font-weight: 600;">₹${formatCurrency(itm.amount)}</td>
//         </tr>
//       `;
//       });
//     } else {
//       itemsRows = `
//       <tr style="border-bottom: 1px solid #e2e8f0;">
//         <td style="padding: 8px; text-align: center;">1</td>
//         <td style="padding: 8px;"><strong>${item.vehicle_no || 'N/A'}</strong></td>
//         <td style="padding: 8px;">${item.description || (isBill ? 'Service Charges' : 'Payment Received')}</td>
//         <td style="padding: 8px; text-align: center;">${item.date ? new Date(item.date).toLocaleDateString('en-IN') : formattedDate}</td>
//         <td style="padding: 8px; text-align: right; font-weight: 600;">₹${formatCurrency(item.amt)}</td>
//       </tr>
//     `;
//     }

//     const totalAmount = parseFloat(item.amt) || 0;

//     const showPaymentDetails = isBill && item.receipt_amount > 0;
//     const paymentSectionHtml = showPaymentDetails ? `
//     <div style="background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%); border-left: 4px solid #2e7d32; padding: 10px 15px; margin: 15px 0; border-radius: 6px; font-size: 12px;">
//       <div style="display: flex; justify-content: space-between; flex-wrap: wrap; gap: 10px;">
//         <span><strong>💰 Amount Paid:</strong> ₹${formatCurrency(item.receipt_amount)}</span>
//         <span><strong>⚖️ Balance:</strong> ₹${formatCurrency(totalAmount - item.receipt_amount)}</span>
//         <span><strong>📊 Status:</strong> <span style="color: ${item.is_pending ? '#e65100' : '#2e7d32'}; font-weight: bold;">${item.is_pending ? 'Partially Paid' : 'Fully Settled'}</span></span>
//       </div>
//     </div>
//   ` : '';

//     // base64 format of the logo provided in the instruction
//     const logoSrc = logo

//     printWindow.document.write(`
//     <!DOCTYPE html>
//     <html>
//     <head>
//       <meta charset="UTF-8">
//       <title>${titleText} - ${item.ref_no}</title>
//       <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@500;700;800&family=Poppins:wght@400;500;600;700&display=swap" rel="stylesheet">
//       <style>
//         * {
//           margin: 0;
//           padding: 0;
//           box-sizing: border-box;
//         }
//         html, body {
//           height: 100%;
//           background: #eef2f5;
//           font-family: 'Poppins', sans-serif;
//         }
//         body {
//           padding: 20px;
//           display: flex;
//           justify-content: center;
//         }

//         /* Master Print Table Outer Frame */
//         .print-master-table {
//           width: 850px;
//           min-height: 100%;
//           background: white;
//           margin: 0 auto;
//           box-shadow: 0 10px 30px rgba(0,0,0,0.08);
//           border-collapse: collapse;
//           position: relative;
//         }

//         @media print {
//           body {
//             background: white;
//             padding: 0;
//             margin: 0;
//           }
//           .print-master-table {
//             box-shadow: none;
//             width: 100%;
//           }
//           /* Forces background colors/gradients to show up on print copies */
//           * {
//             -webkit-print-color-adjust: exact !important;
//             print-color-adjust: exact !important;
//           }

//           /* Footer Fix at Bottom for Printing */
//           .lh-footer-wrapper {
//             position: fixed;
//             bottom: 0;
//             left: 0;
//             width: 100%;
//           }
//           .content-area-cell {
//             padding-bottom: 180px; /* Space so content doesn't overlap the fixed footer */
//           }
//         }

//         @media screen {
//           .lh-footer-wrapper {
//             position: absolute;
//             bottom: 0;
//             left: 0;
//             width: 100%;
//           }
//           .content-area-cell {
//             padding-bottom: 180px;
//           }
//         }

//         /* COMPACT HEADER STYLING */
//         .lh-header-container {
//           padding: 20px 30px 10px 30px;
//           background: white;
//           position: relative;
//         }
//         .top-accent-bar {
//           position: absolute;
//           top: 0;
//           left: 0;
//           right: 0;
//           height: 12px;
//           background: linear-gradient(90deg, #103f7a 72%, #1c7c34 72%);
//         }
//         .lh-header-main {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-top: 5px;
//         }
//         .lh-logo-container {
//           width: 130px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//         }
//         .lh-logo-img {
//           width: 100%;
//           max-height: 95px;
//           object-fit: contain;
//         }
//         .lh-brand-section {
//           flex-grow: 1;
//           padding-left: 20px;
//         }
//         .lh-main-title {
//           font-family: 'Montserrat', sans-serif;
//           font-size: 23px;
//           font-weight: 800;
//           color: #e31e24;
//           letter-spacing: 0.2px;
//           line-height: 1.1;
//           margin-bottom: 4px;
//         }
//         .lh-divider-line {
//           height: 1.5px;
//           background-color: #103f7a;
//           margin-bottom: 6px;
//         }
//         .lh-services-grid {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 3px 8px;
//           max-width: 450px;
//         }
//         .lh-service-item {
//           font-size: 8.5px;
//           font-weight: 700;
//           color: #0c2340;
//           display: flex;
//           align-items: center;
//         }
//         .lh-service-item::after {
//           content: "|";
//           color: #1c7c34;
//           margin-left: 8px;
//         }
//         .lh-services-grid .lh-service-item:last-child::after {
//           content: "";
//         }
//         .lh-contacts {
//           text-align: left;
//           border-left: 2px solid #e2e8f0;
//           padding-left: 12px;
//           min-width: 170px;
//         }
//         .lh-owner-name {
//           font-size: 11px;
//           font-weight: 700;
//           color: #103f7a;
//           margin-bottom: 2px;
//         }
//         .lh-phone-num {
//           font-size: 11px;
//           font-weight: 700;
//           color: #2d3748;
//           display: flex;
//           align-items: center;
//           gap: 4px;
//         }

//         /* METADATA INFO BAR */
//         .bill-info-bar {
//           background: #f8fafc;
//           padding: 8px 30px;
//           display: flex;
//           justify-content: space-between;
//           flex-wrap: wrap;
//           border-top: 1px solid #e2e8f0;
//           border-bottom: 1px solid #e2e8f0;
//         }
//         .info-group {
//           display: flex;
//           gap: 20px;
//           flex-wrap: wrap;
//         }
//         .info-item {
//           font-size: 11.5px;
//         }
//         .info-label {
//           font-weight: 600;
//           color: #64748b;
//         }
//         .info-value {
//           font-weight: 700;
//           color: #1e293b;
//           margin-left: 4px;
//         }

//         /* MAIN BODY CONTENT AREA & WATERMARK */
//         .content-area-cell {
//           padding: 15px 30px 25px 30px;
//           vertical-align: top;
//           position: relative;
//         }
//         .watermark-wrapper {
//           position: absolute;
//           top: 40%;
//           left: 50%;
//           transform: translate(-50%, -50%) rotate(-12deg);
//           width: 40%;
//           opacity: 0.04;
//           pointer-events: none;
//           z-index: 0;
//         }
//         .watermark-img {
//           width: 100%;
//           object-fit: contain;
//         }
//         .section-title-modern {
//           font-family: 'Montserrat', sans-serif;
//           font-size: 14px;
//           font-weight: 700;
//           color: #103f7a;
//           margin-bottom: 12px;
//           padding-bottom: 4px;
//           border-bottom: 2px solid #e2e8f0;
//           letter-spacing: 0.5px;
//         }

//         /* INVOICE CONTENT TABLE */
//         .items-table {
//           width: 100%;
//           border-collapse: collapse;
//           margin-bottom: 15px;
//           position: relative;
//           z-index: 1;
//         }
//         .items-table th {
//           background: #f1f5f9;
//           padding: 10px 8px;
//           font-size: 11px;
//           font-weight: 700;
//           text-transform: uppercase;
//           color: #334155;
//           border-bottom: 2px solid #cbd5e1;
//           text-align: left;
//           }
//         .items-table th:last-child {
//           text-align: right;
//         }
//         .items-table td {
//           font-size: 12px;
//           color: #1e293b;
//         }

//         /* STATEMENT SUMMARY BOXES */
//         .total-section {
//           padding: 12px 15px;
//           background: #fffbeb;
//           border: 1px solid #fef08a;
//           border-radius: 4px;
//           display: flex;
//           justify-content: flex-end;
//           margin-bottom: 15px;
//           position: relative;
//           z-index: 1;
//         }
//         .total-amount-large {
//           font-size: 18px;
//           font-weight: 800;
//           color: #103f7a;
//         }
//         .total-amount-large span {
//           font-size: 12px;
//           font-weight: 600;
//           color: #64748b;
//           margin-right: 6px;
//         }

//         /* FIXED BOTTOM FOOTER DESIGN */
//         .lh-footer-container {
//           background: #0d1e3d;
//           color: white;
//           width: 100%;
//         }
//         .lh-footer-top-curve {
//           background: #103f7a;
//           padding: 10px 30px;
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           border-top-left-radius: 30px;
//         }
//         .lh-footer-address {
//           font-size: 10px;
//           font-weight: 500;
//           max-width: 480px;
//           line-height: 1.4;
//           display: flex;
//           align-items: center;
//           gap: 6px;
//         }
//         .lh-footer-email-box {
//           background: #1c7c34;
//           padding: 5px 12px;
//           border-radius: 15px;
//           font-size: 10.5px;
//           font-weight: 600;
//           display: flex;
//           align-items: center;
//           gap: 5px;
//           border-top-left-radius: 0px;
//           white-space: nowrap;
//         }
//         .lh-footer-logos-pane {
//           background: white;
//           padding: 8px 30px;
//           display: flex;
//           justify-content: flex-end;
//           align-items: center;
//           gap: 15px;
//           border-top-left-radius: 30px;
//           margin-top: -4px;
//         }
//         .lh-partner-logo {
//           height: 24px;
//           object-fit: contain;
//         }
//         .lh-footer-hindi-bar {
//           background: #051429;
//           padding: 8px 30px;
//           text-align: center;
//         }
//         .lh-hindi-grid {
//           display: flex;
//           flex-wrap: wrap;
//           justify-content: center;
//           gap: 4px 12px;
//         }
//         .lh-hindi-item {
//           font-size: 10px;
//           font-weight: 500;
//           color: #cbd5e1;
//         }
//         .lh-hindi-item::after {
//           content: "|";
//           color: #1c7c34;
//           margin-left: 12px;
//         }
//         .lh-hindi-grid .lh-hindi-item:last-child::after {
//           content: "";
//         }
//         .powered-by-tag {
//           font-size: 7.5px;
//           color: #94a3b8;
//           text-align: center;
//           padding: 3px;
//           background: #020b17;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }
//       </style>
//     </head>
//     <body>

//       <table class="print-master-table">

//         <thead>
//           <tr>
//             <td>
//               <div class="lh-header-container">
//                 <div class="top-accent-bar"></div>
//                 <div class="lh-header-main">
//                   <div class="lh-logo-container">
//                     <img class="lh-logo-img" src="${logoSrc}" alt="DK RTO Logo" />
//                   </div>

//                   <div class="lh-brand-section">
//                     <div class="lh-main-title">D.K. RTO & INSURANCE ADVISOR</div>
//                     <div class="lh-divider-line"></div>
//                     <div class="lh-services-grid">
//                       <span class="lh-service-item">DRIVING LICENCE</span>
//                       <span class="lh-service-item">INSURANCE</span>
//                       <span class="lh-service-item">ROAD TAX</span>
//                       <span class="lh-service-item">PERMIT</span>
//                       <span class="lh-service-item">NAME TRANSFER</span>
//                       <span class="lh-service-item">HSRP NO. PLATE</span>
//                       <span class="lh-service-item">FITNESS & OTHER RTO WORK</span>
//                     </div>
//                   </div>
//                   <br/><br/>
//                   <div class="lh-contacts">
//                     <div class="lh-owner-name">Durgesh Kumar Siware</div>
//                     <div class="lh-phone-num">📞 79749 97280</div>
//                     <div class="lh-phone-num" style="margin-top: 1px;">📞 73890 42205</div>
//                   </div>
//                 </div>
//               </div>

//               <div class="bill-info-bar">
//                 <div class="info-group">
//                   <div class="info-item"><span class="info-label">${refLabel}:</span><span class="info-value">${item.ref_no}</span></div>
//                   <div class="info-item"><span class="info-label">Date:</span><span class="info-value">${item.date ? new Date(item.date).toLocaleDateString('en-IN') : formattedDate}</span></div>
//                   <div class="info-item"><span class="info-label">Party Name:</span><span class="info-value">${item.party}</span></div>
//                   <div class="info-item"><span class="info-label">Mobile:</span><span class="info-value">${item.mobile_no || 'N/A'}</span></div>
//                 </div>
//                 <div class="info-item"><span class="info-label">Print Date:</span><span class="info-value">${formattedDate}</span></div>
//               </div>
//             </td>
//           </tr>
//         </thead>

//         <tbody>
//           <tr>
//             <td class="content-area-cell">
//               <div class="watermark-wrapper">
//                 <img class="watermark-img" src="${logoSrc}" alt="Watermark" />
//               </div>

//               <div class="section-title-modern">${titleText}</div>

//               <table class="items-table">
//                 <thead>
//                   <tr>
//                     <th style="width: 8%;">#</th>
//                     <th style="width: 22%;">Vehicle No</th>
//                     <th style="width: 40%;">Description</th>
//                     <th style="width: 15%;">Service Date</th>
//                     <th style="width: 15%;">Amount</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   ${itemsRows}
//                 </tbody>
//               </table>

//               <div class="total-section">
//                 <div class="total-amount-large">
//                   <span>TOTAL AMOUNT:</span> ₹${formatCurrency(totalAmount)}
//                 </div>
//               </div>

//               <div class="payment-details-card">
//                 ${paymentSectionHtml}
//               </div>
//             </td>
//           </tr>
//         </tbody>

//       </table>

//       <div class="lh-footer-wrapper">
//         <div class="lh-footer-container">
//           <div class="lh-footer-top-curve">
//             <div class="lh-footer-address">
//               📍 Near Babla Fuels, Piyush Seat Cover Road, Parking No. 1, Transport Nagar, Raipur (C.G.) 493221
//             </div>
//             <div class="lh-footer-email-box">
//               ✉ durgeshshivare@gmail.com
//             </div>
//           </div>

//           <div class="lh-footer-logos-pane">
//             <svg class="lh-partner-logo" viewBox="0 0 100 40" xmlns="http://www.w3.org/2000/svg">
//               <rect width="100" height="40" rx="3" fill="#0f4c81"/>
//               <circle cx="20" cy="20" r="10" fill="white" opacity="0.2"/>
//               <text x="60" y="21" font-family="sans-serif" font-weight="bold" font-size="8.5" fill="white" text-anchor="middle">UNITED INDIA</text>
//               <text x="60" y="30" font-family="sans-serif" font-size="6.5" fill="#cbd5e1" text-anchor="middle">INSURANCE</text>
//             </svg>
//             <svg class="lh-partner-logo" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
//               <circle cx="20" cy="20" r="17" fill="#103f7a" stroke="#7ac143" stroke-width="1.5"/>
//               <path d="M15,12 L18,10 L22,13 L25,11 L28,16 L24,22 L26,28 L20,32 L16,28 L13,24 L16,18 Z" fill="white" opacity="0.85"/>
//             </svg>
//           </div>

//           <div class="lh-footer-hindi-bar">
//             <div class="lh-hindi-grid">
//               <span class="lh-hindi-item">ड्राइविंग लाइसेंस</span>
//               <span class="lh-hindi-item">इंश्योरेंस</span>
//               <span class="lh-hindi-item">रोड टैक्स</span>
//               <span class="lh-hindi-item">परमिट</span>
//               <span class="lh-hindi-item">नाम ट्रांसफर</span>
//               <span class="lh-hindi-item">HSRP नं. प्लेट</span>
//               <span class="lh-hindi-item">फिटनेस</span>
//               <span class="lh-hindi-item">आर.टी.ओ वर्क</span>
//             </div>
//           </div>

//           <div class="powered-by-tag">
//             powered by yashvitech IT solution
//           </div>
//         </div>
//       </div>

//       <script>
//         // Open print dialog when page loads
//         window.onload = function() { 
//           window.print();
//           // Removed the setTimeout that was automatically closing the window
//           // This allows users to keep the print preview open and perform other activities
//         };
//       </script>
//     </body>
//     </html>
//   `);
//     printWindow.document.close();
//   };

//   const handleViewDetails = (item) => {
//     setSelectedTransaction(item);
//     setModal({ type: 'view', data: item });
//   };

//   if (stats.loading) {
//     return (
//       <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//         <Card>
//           <DashboardOutlined spin style={{ fontSize: 40, color: '#1890ff' }} />
//           <div style={{ marginTop: 16 }}>Loading Dashboard...</div>
//         </Card>
//       </div>
//     );
//   }

//   const pending = stats.pendingAmount;
//   const collectionRate = (stats.collectionRate * 100).toFixed(1);

//   // Styled Stat Cards
//   const statCards = [
//     {
//       title: 'Total Bills',
//       value: stats.totalBills,
//       prefix: '₹',
//       icon: <FileTextOutlined style={{ fontSize: 32, color: '#1890ff' }} />,
//       color: '#1890ff',
//       bg: '#e6f7ff',
//       trend: `₹${stats.totalBills.toLocaleString()}`
//     },
//     {
//       title: 'Total Receipts',
//       value: stats.totalReceipts,
//       prefix: '₹',
//       icon: <CheckCircleOutlined style={{ fontSize: 32, color: '#52c41a' }} />,
//       color: '#52c41a',
//       bg: '#f6ffed',
//       trend: `₹${stats.totalReceipts.toLocaleString()}`
//     },
//     {
//       title: 'Pending Amount',
//       value: pending,
//       prefix: '₹',
//       icon: <WalletOutlined style={{ fontSize: 32, color: '#ff4d4f' }} />,
//       color: '#ff4d4f',
//       bg: '#fff1f0',
//       trend: pending > 0 ? 'Due' : 'Paid'
//     },
//     {
//       title: 'Collection Rate',
//       value: collectionRate,
//       suffix: '%',
//       icon: <RiseOutlined style={{ fontSize: 32, color: '#fa8c16' }} />,
//       color: '#fa8c16',
//       bg: '#fff7e6',
//       trend: `${collectionRate}% Collected`
//     },
//     {
//       title: 'Total Vehicles',
//       value: stats.totalVehicles,
//       icon: <TruckOutlined style={{ fontSize: 32, color: '#722ed1' }} />,
//       color: '#722ed1',
//       bg: '#f9f0ff',
//       trend: 'Active Vehicles'
//     },
//     {
//       title: 'Transactions',
//       value: stats.totalTransactions,
//       icon: <ReconciliationOutlined style={{ fontSize: 32, color: '#13c2c2' }} />,
//       color: '#13c2c2',
//       bg: '#e6fffa',
//       trend: 'Total Entries'
//     }
//   ];

//   return (
//     <div style={{ minHeight: '100vh' }}>
//       {/* Stats Cards */}
//       <Row gutter={[16, 16]}>
//         {statCards.map((card, index) => {
//           const colors = [
//             "#1677ff",
//             "#52c41a",
//             "#ff4d4f",
//             "#fa8c16",
//             "#722ed1",
//             "#13c2c2"
//           ];

//           const gradients = [
//             "linear-gradient(135deg,#1677ff,#69b1ff)",
//             "linear-gradient(135deg,#52c41a,#95de64)",
//             "linear-gradient(135deg,#ff4d4f,#ff7875)",
//             "linear-gradient(135deg,#fa8c16,#ffd666)",
//             "linear-gradient(135deg,#722ed1,#b37feb)",
//             "linear-gradient(135deg,#13c2c2,#87e8de)"
//           ];

//           return (
//             <Col xs={24} sm={12} md={12} lg={8} xl={8} key={index}>
//               <motion.div
//                 initial={{ opacity: 0, y: 25 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{
//                   duration: 0.4,
//                   delay: index * 0.1
//                 }}
//                 whileHover={{
//                   y: -4
//                 }}
//                 style={{
//                   borderRadius: "16px",
//                   overflow: "hidden",
//                   position: "relative",
//                   background: "#fff",
//                   boxShadow: "0 4px 15px rgba(0,0,0,0.06)",
//                   minHeight: "140px"
//                 }}
//               >
//                 <div
//                   style={{
//                     height: "5px",
//                     background: gradients[index]
//                   }}
//                 />

//                 <div style={{ padding: "16px" }}>
//                   <div
//                     style={{
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center"
//                     }}
//                   >
//                     <div>
//                       <div
//                         style={{
//                           fontSize: 11,
//                           fontWeight: 700,
//                           color: "#8c8c8c",
//                           textTransform: "uppercase"
//                         }}
//                       >
//                         {card.title}
//                       </div>

//                       <div
//                         style={{
//                           marginTop: 8,
//                           fontSize: screens.xs ? 22 : 28,
//                           fontWeight: 800,
//                           color: colors[index]
//                         }}
//                       >
//                         {card.prefix}
//                         {Number(card.value).toLocaleString("en-IN")}
//                         {card.suffix}
//                       </div>
//                     </div>

//                     <div
//                       style={{
//                         width: 52,
//                         height: 52,
//                         borderRadius: "14px",
//                         background: gradients[index],
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center"
//                       }}
//                     >
//                       {React.cloneElement(card.icon, {
//                         style: {
//                           fontSize: 24,
//                           color: "#fff"
//                         }
//                       })}
//                     </div>
//                   </div>

//                   <div
//                     style={{
//                       marginTop: 14,
//                       display: "flex",
//                       justifyContent: "space-between",
//                       alignItems: "center"
//                     }}
//                   >
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 5,
//                         fontSize: 12,
//                         fontWeight: 600,
//                         color: "#595959"
//                       }}
//                     >
//                       <ArrowUpOutlined style={{ color: colors[index] }} />
//                       {card.trend}
//                     </div>

//                     <div
//                       style={{
//                         fontSize: 11,
//                         fontWeight: 700,
//                         color: colors[index]
//                       }}
//                     >
//                       LIVE
//                     </div>
//                   </div>
//                 </div>
//               </motion.div>
//             </Col>
//           );
//         })}
//       </Row>

//       {/* Transactions Section */}
//       <Card
//         style={{ marginTop: 24, borderRadius: 12, overflow: 'hidden' }}
//         bodyStyle={{ padding: 0 }}
//       >
//         <div style={{ padding: screens.xs ? '12px' : '16px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
//           <Row justify="space-between" align="middle" wrap>
//             <Col>
//               <Text strong style={{ fontSize: 16, color: '#1890ff' }}>
//                 {activeView === 'last5' && '📋 Last 5 Transactions'}
//                 {activeView === 'bills' && '💰 All Bills'}
//                 {activeView === 'receipts' && '✅ Last 5 Receipts'}
//               </Text>
//             </Col>
//             <Col>
//               <Space wrap style={{ justifyContent: screens.xs ? 'center' : 'flex-end' }}>
//                 <Segmented
//                   value={activeView}
//                   onChange={(val) => {
//                     setActiveView(val);
//                     setMobilePage(1);
//                   }}
//                   options={[
//                     { label: 'Last 5 Transactions', value: 'last5' },
//                     { label: 'All Pendings Bills', value: 'bills' },
//                     { label: 'Last 5 Receipts', value: 'receipts' }
//                   ]}
//                   size={screens.xs ? 'small' : 'middle'}
//                 />

//                 <Input
//                   placeholder="Search..."
//                   prefix={<SearchOutlined />}
//                   onChange={e => {
//                     setSearchTerm(e.target.value);
//                     setMobilePage(1);
//                   }}
//                   style={{ width: screens.xs ? 150 : 200 }}
//                   size={screens.xs ? 'small' : 'middle'}
//                   allowClear
//                 />

//                 <Button
//                   icon={<DownloadOutlined />}
//                   onClick={exportExcel}
//                   size={screens.xs ? 'small' : 'middle'}
//                   type="primary"
//                   ghost
//                 >
//                   {!screens.xs && 'Export Excel'}
//                 </Button>
//               </Space>
//             </Col>
//           </Row>
//         </div>

//         {isExtraSmall ? (
//           // Mobile View: Collapse Cards
//           <>
//             {paginatedMobileTransactions.length === 0 ? (
//               <Empty
//                 description="No transactions found"
//                 style={{ padding: screens.xs ? 40 : 80 }}
//                 image={Empty.PRESENTED_IMAGE_SIMPLE}
//               />
//             ) : (
//               <div style={{ padding: '12px' }}>
//                 <Collapse
//                   accordion={false}
//                   expandIcon={({ isActive }) => <RightOutlined rotate={isActive ? 90 : 0} />}
//                   expandIconPosition="end"
//                   style={{ background: 'transparent', border: 'none' }}
//                 >
//                   {paginatedMobileTransactions.map((transaction, idx) => (
//                     <Panel
//                       key={transaction.ref_no + idx}
//                       header={
//                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', flexWrap: 'wrap', gap: '8px' }}>
//                           <Space direction="vertical" size={0} style={{ flex: 1 }}>
//                             <Text strong>{transaction.party}</Text>
//                             <Text type="secondary" style={{ fontSize: 12 }}>{transaction.ref_no}</Text>
//                           </Space>
//                           <Space direction="vertical" size={0} align="end">
//                             <Text strong style={{ color: transaction.type === 'Bill' ? '#1890ff' : '#52c41a' }}>
//                               ₹{transaction.amt.toLocaleString('en-IN')}
//                             </Text>
//                             <Badge status={transaction.type === 'Bill' ? 'processing' : 'success'} text={transaction.type} />
//                           </Space>
//                         </div>
//                       }
//                       style={{
//                         marginBottom: 12,
//                         background: '#fff',
//                         borderRadius: 8,
//                         border: '1px solid #f0f0f0',
//                         overflow: 'hidden'
//                       }}
//                     >
//                       <div style={{ padding: '4px 0' }}>
//                         <Descriptions column={1} bordered size="small" labelStyle={{ fontWeight: 600 }}>
//                           <Descriptions.Item label="Reference No">
//                             <Tag color={transaction.type === 'Bill' ? 'blue' : 'green'}>
//                               {transaction.ref_no}
//                             </Tag>
//                           </Descriptions.Item>
//                           <Descriptions.Item label="Date">
//                             <Space>
//                               <CalendarOutlined />
//                               <Text>{transaction.date ? new Date(transaction.date).toLocaleDateString() : 'N/A'}</Text>
//                             </Space>
//                           </Descriptions.Item>
//                           <Descriptions.Item label="Mobile No">
//                             <Text>{transaction.mobile_no || 'N/A'}</Text>
//                           </Descriptions.Item>
//                           {transaction.vehicle_no && transaction.vehicle_no !== 'N/A' && (
//                             <Descriptions.Item label="Vehicle No">
//                               <Text>{transaction.vehicle_no}</Text>
//                             </Descriptions.Item>
//                           )}
//                           {transaction.description && (
//                             <Descriptions.Item label="Description">
//                               {transaction.description}
//                             </Descriptions.Item>
//                           )}
//                         </Descriptions>
//                         <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
//                           <Button
//                             type="link"
//                             icon={<EyeOutlined />}
//                             onClick={() => handleViewDetails(transaction)}
//                           >
//                             View Details
//                           </Button>
//                           <Button
//                             type="link"
//                             icon={<PrinterOutlined />}
//                             onClick={() => handlePrint(transaction)}
//                           >
//                             Print
//                           </Button>
//                         </div>
//                       </div>
//                     </Panel>
//                   ))}
//                 </Collapse>

//                 {activeView === 'bills' && mobileTransactions.length > mobilePageSize && (
//                   <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
//                     <Pagination
//                       current={mobilePage}
//                       pageSize={mobilePageSize}
//                       total={mobileTransactions.length}
//                       onChange={handleMobilePageChange}
//                       size="small"
//                       showSizeChanger={false}
//                     />
//                   </div>
//                 )}
//               </div>
//             )}
//           </>
//         ) : (
//           // Desktop Table View (unchanged)
//           <>
//             {Object.keys(filteredData).length === 0 ? (
//               <Empty
//                 description="No transactions found"
//                 style={{ padding: screens.xs ? 40 : 80 }}
//                 image={Empty.PRESENTED_IMAGE_SIMPLE}
//               />
//             ) : (
//               <Table
//                 size="middle"
//                 pagination={activeView === 'bills' ? {
//                   pageSize: screens.xs ? 5 : 10,
//                   showTotal: (total) => `Total ${total} bills`,
//                   responsive: true
//                 } : false}
//                 dataSource={Object.entries(filteredData).flatMap(([party, items]) =>
//                   items.map((item, index) => ({
//                     key: `${party}_${item.ref_no}_${index}`,
//                     party,
//                     item,
//                     rowSpan: index === 0 ? items.length : 0
//                   }))
//                 )}
//                 rowClassName={(_, index) =>
//                   index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
//                 }
//                 columns={[
//                   {
//                     title: 'Party Name',
//                     dataIndex: 'party',
//                     key: 'party',
//                     width: screens.xs ? 120 : 180,
//                     render: (text, row) => ({
//                       children: (
//                         <Space>
//                           <Avatar size="small" style={{ backgroundColor: '#1890ff' }}>
//                             {text?.charAt(0) || '?'}
//                           </Avatar>
//                           <Text strong>{text}</Text>
//                         </Space>
//                       ),
//                       props: { rowSpan: row.rowSpan }
//                     })
//                   },
//                   {
//                     title: 'Ref No',
//                     key: 'ref_no',
//                     width: 100,
//                     render: (_, r) => (
//                       <Tag color={r.item.type === 'Bill' ? 'blue' : 'green'} style={{ fontWeight: 500 }}>
//                         {r.item.ref_no}
//                       </Tag>
//                     )
//                   },
//                   {
//                     title: 'Type',
//                     key: 'type',
//                     width: 100,
//                     render: (_, r) => (
//                       <Badge
//                         status={r.item.type === 'Bill' ? 'processing' : 'success'}
//                         text={r.item.type}
//                       />
//                     )
//                   },
//                   {
//                     title: 'Amount',
//                     key: 'amount',
//                     width: 120,
//                     align: 'right',
//                     render: (_, r) => (
//                       <Text
//                         strong
//                         style={{
//                           color: r.item.type === 'Bill' ? '#1890ff' : '#52c41a',
//                           fontSize: screens.xs ? 13 : 14
//                         }}
//                       >
//                         ₹{r.item.amt.toLocaleString('en-IN')}
//                       </Text>
//                     )
//                   },
//                   {
//                     title: 'Date',
//                     key: 'date',
//                     width: 110,
//                     render: (_, r) => (
//                       <Space>
//                         <CalendarOutlined style={{ color: '#8c8c8c' }} />
//                         <Text>{r.item.date ? new Date(r.item.date).toLocaleDateString() : 'N/A'}</Text>
//                       </Space>
//                     )
//                   },
//                   {
//                     title: 'Actions',
//                     key: 'actions',
//                     width: 100,
//                     fixed: screens.md ? 'right' : undefined,
//                     render: (_, r) => (
//                       <Space size="small">
//                         <Tooltip title="View Details">
//                           <Button
//                             type="link"
//                             icon={<EyeOutlined />}
//                             onClick={() => handleViewDetails(r.item)}
//                             size="small"
//                           />
//                         </Tooltip>
//                         <Tooltip title="Print">
//                           <Button
//                             type="link"
//                             icon={<PrinterOutlined />}
//                             onClick={() => handlePrint(r.item)}
//                             size="small"
//                           />
//                         </Tooltip>
//                       </Space>
//                     )
//                   }
//                 ]}
//                 scroll={{ x: screens.xs ? 700 : undefined }}
//               />
//             )}
//           </>
//         )}
//       </Card>

//       {/* View Modal */}
//       <Modal
//         open={!!modal && modal.type === 'view'}
//         title={
//           <Space>
//             <EyeOutlined style={{ color: '#1890ff' }} />
//             <span>Transaction Details</span>
//           </Space>
//         }
//         onCancel={() => setModal(null)}
//         footer={[
//           <Button key="print" icon={<PrinterOutlined />} onClick={() => handlePrint(selectedTransaction)}>
//             Print
//           </Button>,
//           <Button key="close" type="primary" onClick={() => setModal(null)}>
//             Close
//           </Button>
//         ]}
//         width={500}
//       >
//         {selectedTransaction && (
//           <Descriptions column={1} bordered size="small">
//             <Descriptions.Item label="Reference No">
//               <Tag color={selectedTransaction.type === 'Bill' ? 'blue' : 'green'}>
//                 {selectedTransaction.ref_no}
//               </Tag>
//             </Descriptions.Item>
//             <Descriptions.Item label="Party Name">
//               <Space>
//                 <Avatar size="small" style={{ backgroundColor: '#1890ff' }}>
//                   {selectedTransaction.party?.charAt(0)}
//                 </Avatar>
//                 <Text strong>{selectedTransaction.party}</Text>
//               </Space>
//             </Descriptions.Item>
//             <Descriptions.Item label="Type">
//               <Badge
//                 status={selectedTransaction.type === 'Bill' ? 'processing' : 'success'}
//                 text={selectedTransaction.type}
//               />
//             </Descriptions.Item>
//             <Descriptions.Item label="Amount">
//               <Text style={{ fontSize: 18, fontWeight: 'bold', color: selectedTransaction.type === 'Bill' ? '#1890ff' : '#52c41a' }}>
//                 ₹{selectedTransaction.amt.toLocaleString('en-IN')}
//               </Text>
//             </Descriptions.Item>
//             <Descriptions.Item label="Date">
//               <Space>
//                 <CalendarOutlined />
//                 <Text>{selectedTransaction.date ? new Date(selectedTransaction.date).toLocaleDateString() : 'N/A'}</Text>
//               </Space>
//             </Descriptions.Item>
//             <Descriptions.Item label="Mobile No">
//               <Text>{selectedTransaction.mobile_no || 'N/A'}</Text>
//             </Descriptions.Item>
//             {selectedTransaction.description && (
//               <Descriptions.Item label="Description">
//                 {selectedTransaction.description}
//               </Descriptions.Item>
//             )}
//           </Descriptions>
//         )}
//       </Modal>

//       {/* Custom CSS for table row striping */}
//       <style>{`
//         .table-row-light {
//           background-color: #ffffff;
//         }
//         .table-row-dark {
//           background-color: #fafafa;
//         }
//         .ant-table-tbody > tr:hover > td {
//           background-color: #e6f7ff !important;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default DashboardContent;

import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import { message } from "antd";

import {
  Row,
  Col,
  Card,
  Table,
  Input,
  Button,
  Modal,
  Tag,
  Space,
  Typography,
  Tooltip,
  Avatar,
  Badge,
  Segmented,
  Empty,
  Descriptions,
  Grid,
  Collapse,
  Pagination
} from 'antd';

import html2pdf from 'html2pdf.js';

import {
  SearchOutlined,
  DownloadOutlined,
  EyeOutlined,
  PrinterOutlined,
  DashboardOutlined,
  CarOutlined,
  WalletOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  CalendarOutlined,
  TruckOutlined,
  RiseOutlined,
  ReconciliationOutlined,
  ArrowUpOutlined,
  RightOutlined
} from '@ant-design/icons';
import { motion } from "framer-motion";
import logo from '../Logo.png'
// Import services from Services
import { getPendingBills, getReceipts, getDashboardData } from '../Services/Services';

const { Text, Title } = Typography;
const { useBreakpoint } = Grid;
const { Panel } = Collapse;

const DashboardContent = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md; // mobile view for screens < 992px? adjust as needed. Use xs or sm.
  // Better: isMobile = screens.xs === true (extra small)
  const isExtraSmall = screens.xs;

  const [stats, setStats] = useState({
    totalBills: 0,
    totalReceipts: 0,
    pendingAmount: 0,
    collectionRate: 0,
    totalVehicles: 0,
    totalTransactions: 0,
    loading: true
  });

  const [searchTerm, setSearchTerm] = useState('');
  const [modal, setModal] = useState(null);
  const [activeView, setActiveView] = useState('last5');
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [allBills, setAllBills] = useState([]);
  const [allReceipts, setAllReceipts] = useState([]);
  const [mobilePage, setMobilePage] = useState(1);
  const mobilePageSize = 5;

  // Helper function to get vehicle number from bill
  const getVehicleNo = (bill) => {
    if (bill.vehicle_no) return bill.vehicle_no;
    if (bill.items && bill.items.length > 0 && bill.items[0].vehicle_no) {
      return bill.items[0].vehicle_no;
    }
    return 'N/A';
  };

  // Helper function to get mobile number from bill
  const getMobileNo = (bill) => {
    if (bill.mobile_no) return bill.mobile_no;
    if (bill.items && bill.items.length > 0 && bill.items[0].mobile) {
      return bill.items[0].mobile;
    }
    return 'N/A';
  };

  // Helper function to get description from bill
  const getDescription = (bill) => {
    if (bill.description) return bill.description;
    if (bill.items && bill.items.length > 0) {
      return bill.items.map(item => item.description).filter(Boolean).join(', ');
    }
    return '';
  };

  const fetchDashboardData = async () => {
    try {
      // Fetch dashboard summary data
      const dashboardData = await getDashboardData();

      // Fetch bills and receipts for transaction details
      const [billsData, receiptsData] = await Promise.all([
        getPendingBills(),
        getReceipts()
      ]);

      // Extract the data array from the response structure
      const bills = billsData?.data || billsData?.results || billsData || [];
      const receipts = receiptsData?.data || receiptsData?.results || receiptsData || [];

      const billsMapped = bills.map(b => ({
        ...b,
        type: 'Bill',
        amt: Number(b.total_amount || 0),
        ref_no: b.bill_id || b.id,
        party: b.party_name || 'General',
        date: b.bill_date,
        vehicle_no: getVehicleNo(b),
        mobile_no: getMobileNo(b),
        description: getDescription(b),
        timestamp: new Date(b.bill_date).getTime()
      }));

      const receiptsMapped = receipts.map(r => ({
        ...r,
        type: 'Receipt',
        amt: Number(r.amount || 0),
        ref_no: r.receipt_no || r.id,
        party: r.received_from || 'General',
        date: r.receipt_date,
        vehicle_no: r.vehicle_no || 'N/A',
        description: r.description || '',
        mobile_no: r.mobile_no || 'N/A',
        timestamp: new Date(r.receipt_date).getTime()
      }));

      // Sort bills and receipts by date (newest first)
      const sortedBills = billsMapped.sort((a, b) => new Date(b.date) - new Date(a.date));
      const sortedReceipts = receiptsMapped.sort((a, b) => new Date(b.date) - new Date(a.date));

      setAllBills(sortedBills);
      setAllReceipts(sortedReceipts);

      // Calculate summary stats
      const totalBills = bills.length;
      const totalReceipts = receipts.length;
      const totalPendingAmount = bills.reduce((sum, b) => sum + Number(b.total_amount || 0), 0);
      const uniqueVehicles = new Set();
      bills.forEach(b => {
        const vehicle = getVehicleNo(b);
        if (vehicle !== 'N/A') uniqueVehicles.add(vehicle);
      });
      receipts.forEach(r => {
        if (r.vehicle_no && r.vehicle_no !== 'N/A') uniqueVehicles.add(r.vehicle_no);
      });

      // Use dashboard data for stats if available, otherwise calculate from fetched data
      setStats({
        totalBills: dashboardData?.total_bills || totalBills,
        totalReceipts: dashboardData?.total_receipts || totalReceipts,
        pendingAmount: dashboardData?.pending_amount || totalPendingAmount,
        collectionRate: dashboardData?.collection_rate || 0,
        totalVehicles: dashboardData?.total_vehicles || uniqueVehicles.size,
        totalTransactions: dashboardData?.transactions || (bills.length + receipts.length),
        loading: false
      });

    } catch (err) {
      console.error('Error fetching dashboard data:', err);
      message.error('Failed to fetch dashboard data');
      setStats(prev => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    fetchDashboardData();
    // Refresh data every 30 seconds
    const interval = setInterval(fetchDashboardData, 30000);
    return () => clearInterval(interval);
  }, []);

  // Get grouped data for desktop table view
  const getDisplayData = () => {
    if (activeView === 'last5') {
      let allTransactions = [...allBills, ...allReceipts];
      if (searchTerm) {
        allTransactions = allTransactions.filter(t =>
          t.party.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.ref_no?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.vehicle_no?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
      const sortedAll = allTransactions.sort((a, b) => new Date(b.date) - new Date(a.date));
      const last5 = sortedAll.slice(0, 5);
      // Group by party for display
      const grouped = last5.reduce((acc, item) => {
        if (!acc[item.party]) acc[item.party] = [];
        acc[item.party].push(item);
        return acc;
      }, {});
      return grouped;
    }
    else if (activeView === 'bills') {
      // Show all bills
      let filteredBills = [...allBills];
      if (searchTerm) {
        filteredBills = filteredBills.filter(t =>
          t.party.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.ref_no?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.vehicle_no?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
      const grouped = filteredBills.reduce((acc, item) => {
        if (!acc[item.party]) acc[item.party] = [];
        acc[item.party].push(item);
        return acc;
      }, {});
      return grouped;
    }
    else if (activeView === 'receipts') {
      // Show last 5 receipts only
      const last5Receipts = allReceipts.slice(0, 5);
      let filteredReceipts = [...last5Receipts];
      if (searchTerm) {
        filteredReceipts = filteredReceipts.filter(t =>
          t.party.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.ref_no?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.vehicle_no?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
      const grouped = filteredReceipts.reduce((acc, item) => {
        if (!acc[item.party]) acc[item.party] = [];
        acc[item.party].push(item);
        return acc;
      }, {});
      return grouped;
    }
    return {};
  };

  // Get flattened transactions for mobile view
  const getMobileTransactions = () => {
    let transactions = [];
    if (activeView === 'last5') {
      let allTransactions = [...allBills, ...allReceipts];
      if (searchTerm) {
        allTransactions = allTransactions.filter(t =>
          t.party.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.ref_no?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.vehicle_no?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
      transactions = allTransactions.sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 5);
    } else if (activeView === 'bills') {
      transactions = [...allBills];
      if (searchTerm) {
        transactions = transactions.filter(t =>
          t.party.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.ref_no?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.vehicle_no?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
      // sort newest first
      transactions.sort((a, b) => new Date(b.date) - new Date(a.date));
    } else if (activeView === 'receipts') {
      transactions = allReceipts.slice(0, 5);
      if (searchTerm) {
        transactions = transactions.filter(t =>
          t.party.toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.ref_no?.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
          t.vehicle_no?.toLowerCase().includes(searchTerm.toLowerCase())
        );
      }
      // sort newest first
      transactions.sort((a, b) => new Date(b.date) - new Date(a.date));
    }
    return transactions;
  };

  const filteredData = getDisplayData();
  const mobileTransactions = getMobileTransactions();

  // Pagination for mobile bills view
  const paginatedMobileTransactions = activeView === 'bills'
    ? mobileTransactions.slice((mobilePage - 1) * mobilePageSize, mobilePage * mobilePageSize)
    : mobileTransactions;

  const handleMobilePageChange = (page) => {
    setMobilePage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const exportExcel = () => {
    // Prepare summary data
    const totalBillsAmount = allBills.reduce((sum, item) => sum + item.amt, 0);
    const totalReceiptsAmount = allReceipts.reduce((sum, item) => sum + item.amt, 0);
    const last5Transactions = [...allBills, ...allReceipts]
      .sort((a, b) => new Date(b.date) - new Date(a.date))
      .slice(0, 5);

    const summaryData = [{
      'Report Generated On': new Date().toLocaleString(),
      'Generated By': 'DK RTO AND INSURANCE ADVISOR',
      'Total Bills': stats.totalBills,
      'Total Bills Amount (₹)': totalBillsAmount.toLocaleString('en-IN'),
      'Total Receipts': stats.totalReceipts,
      'Total Receipts Amount (₹)': totalReceiptsAmount.toLocaleString('en-IN'),
      'Pending Amount (₹)': stats.pendingAmount.toLocaleString('en-IN'),
      'Collection Rate (%)': (stats.collectionRate * 100).toFixed(2),
      'Total Vehicles': stats.totalVehicles,
      'Total Transactions': allBills.length + allReceipts.length
    }];

    // Prepare all bills data
    const allBillsData = allBills.map((item, index) => ({
      'S.No': index + 1,
      'Party Name': item.party,
      'Bill No': item.ref_no,
      'Amount (₹)': item.amt.toLocaleString('en-IN'),
      'Bill Date': item.date ? new Date(item.date).toLocaleDateString('en-IN') : 'N/A',
      'Mobile No': item.mobile_no || 'N/A',
      'Description': item.description || ''
    }));

    // Prepare all receipts data (full list)
    const allReceiptsData = allReceipts.map((item, index) => ({
      'S.No': index + 1,
      'Party Name': item.party,
      'Receipt No': item.ref_no,
      'Amount (₹)': item.amt.toLocaleString('en-IN'),
      'Receipt Date': item.date ? new Date(item.date).toLocaleDateString('en-IN') : 'N/A',
      'Mobile No': item.mobile_no || 'N/A',
      'Description': item.description || ''
    }));

    // Prepare last 5 transactions data
    const last5Data = last5Transactions.map((item, index) => ({
      'S.No': index + 1,
      'Party Name': item.party,
      'Reference No': item.ref_no,
      'Type': item.type,
      'Amount (₹)': item.amt.toLocaleString('en-IN'),
      'Date': item.date ? new Date(item.date).toLocaleDateString('en-IN') : 'N/A',
      'Mobile No': item.mobile_no || 'N/A',
      'Description': item.description || ''
    }));

    // Create workbook
    const wb = XLSX.utils.book_new();

    // Helper to add sheet with auto column width
    const addSheetWithAutoWidth = (data, sheetName) => {
      const ws = XLSX.utils.json_to_sheet(data);

      // Auto-set column widths
      const colWidths = [];
      if (data.length > 0) {
        Object.keys(data[0]).forEach((key, idx) => {
          let maxLength = key.length;
          data.forEach(row => {
            const value = row[key]?.toString() || '';
            maxLength = Math.max(maxLength, value.length);
          });
          colWidths[idx] = { wch: Math.min(maxLength + 2, 40) };
        });
      }
      ws['!cols'] = colWidths;

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    };

    // Add all sheets
    addSheetWithAutoWidth(summaryData, '📊 Summary');
    addSheetWithAutoWidth(last5Data, '📋 Last 5 Transactions');
    addSheetWithAutoWidth(allBillsData, '💰 All Bills');
    addSheetWithAutoWidth(allReceiptsData, '✅ All Receipts');

    // Save file
    const fileName = `RTO_Report_${new Date().toISOString().split('T')[0]}.xlsx`;
    XLSX.writeFile(wb, fileName);

    message.success({
      content: 'Excel report exported successfully!',
      duration: 3
    });
  };

  // Print format (unchanged, fully functional)
  const handlePrint = (item) => {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });

    // Helper function to format currency
    const formatCurrency = (amount) => {
      if (isNaN(amount)) return '0.00';
      return parseFloat(amount).toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    };

    const isBill = item.type === 'Bill';
    const titleText = isBill ? 'SERVICE BILL / VOUCHER' : 'PAYMENT RECEIPT';
    const refLabel = isBill ? 'Bill No' : 'Receipt No';

    // Build items rows HTML
    let itemsRows = '';
    if (isBill && item.items && item.items.length > 0) {
      item.items.forEach((itm, idx) => {
        itemsRows += `
          <tr style="border-bottom: 1px solid #cbd5e1; background: #ffffff;">
            <td style="padding: 10px 8px; text-align: center;">${idx + 1}</td>
            <td style="padding: 10px 8px;">${itm.vehicle_no || '-'}</td>
            <td style="padding: 10px 8px;">${itm.description || '-'}</td>
            <td style="padding: 10px 8px; text-align: center;">${itm.service_date || item.date || '-'}</td>
            <td style="padding: 10px 8px; text-align: right;">${formatCurrency(itm.amount)}</td>
          </tr>
        `;
      });
    } else {
      itemsRows = `
        <tr style="border-bottom: 1px solid #cbd5e1; background: #ffffff;">
          <td style="padding: 10px 8px; text-align: center;">1</td>
          <td style="padding: 10px 8px;">${item.vehicle_no || 'N/A'}</td>
          <td style="padding: 10px 8px;">${item.description || (isBill ? 'Service Charges' : 'Payment Received')}</td>
          <td style="padding: 10px 8px; text-align: center;">${item.date ? new Date(item.date).toLocaleDateString('en-IN') : formattedDate}</td>
          <td style="padding: 10px 8px; text-align: right;">${formatCurrency(item.amt)}</td>
        </tr>
      `;
    }

    const totalAmount = parseFloat(item.amt) || 0;

    const showPaymentDetails = isBill && item.receipt_amount > 0;
    const paymentSectionHtml = showPaymentDetails ? `
      <div style="background: #f0fdf4; border: 1px solid #bbf7d0; padding: 10px 12px; margin: 15px 0; border-radius: 3px; font-size: 11px; color: #166534;">
        <table style="width: 100%; border-collapse: collapse; font-family: 'Times New Roman', Times, serif;">
          <tr>
            <td><strong>💰 Amount Paid:</strong> ₹${formatCurrency(item.receipt_amount)}</td>
            <td style="text-align: center;"><strong>⚖️ Balance:</strong> ₹${formatCurrency(totalAmount - item.receipt_amount)}</td>
            <td style="text-align: right;"><strong>📊 Status:</strong> <span style="font-weight: bold; color: ${item.is_pending ? '#9a3412' : '#166534'};">${item.is_pending ? 'Partially Paid' : 'Fully Settled'}</span></td>
          </tr>
        </table>
      </div>
    ` : '';

    const logoSrc = logo;

    // Create Temporary DOM Element for background rendering
    const element = document.createElement('div');
    element.innerHTML = `
      <div style="width: 100%; max-width: 1000px; margin: 0 auto; background: #ffffff; font-family: 'Times New Roman', Times, serif; box-sizing: border-box; border: 1px solid #a3a3a3; padding: 15px; border-radius: 4px;">
        
        <!-- TOP GRADIENT ACCENT LAYER -->
        <div style="height: 5px; background: linear-gradient(90deg, #103f7a 75%, #1c7c34 75%); margin: -15px -15px 15px -15px; border-radius: 4px 4px 0 0;"></div>

        <!-- HEADER SECTION -->
        <div style="padding: 5px 10px 15px 10px; background: #ffffff;">
          <div style="display: flex; justify-content: space-between; align-items: center; gap: 20px;">
            <!-- LOGO -->
            <div style="width: 85px; min-width: 85px; display: flex; align-items: center; justify-content: center;">
              <img src="${logoSrc}" style="width:100%; height:auto;" />
            </div>
            <!-- BRAND CONSULTANCY INFO -->
            <div style="flex:1; text-align: center;">
              <div style="font-size: 24px; font-weight: bold; color: #103f7a; letter-spacing: 0.5px; line-height: 1.2;">D.K. TRANSPORT CONSULTANCY</div>
              <div style="font-size: 10.5px; color: #334155; margin-top: 5px; text-transform: uppercase; letter-spacing: 0.3px;">
                PARKING NO. 1 BABLA FUELS KE BAJU T P NAGAR RAWABHATA RAIPUR
              </div>
              <div style="font-size: 10px; color: #1c7c34; font-style: italic; margin-top: 3px;">
                (Deal in all RTO related matters, Insurance - 2 Wheeler, 4 Wheeler, Commercial Vehicles)
              </div>
            </div>
            <!-- OWNER CONTACT -->
            <div style="text-align: right; border-left: 1px solid #cbd5e1; padding-left: 15px; min-width: 150px; font-size: 11px; color: #334155;">
              <div style="font-size: 12px; font-weight: bold; color: #103f7a; margin-bottom: 3px;">Durgesh Kumar Siware</div>
              <div style="margin-bottom: 2px;">📞 79749 97280</div>
              <div>📞 73890 42205</div>
            </div>
          </div>
        </div>

        <!-- INVOICE/RECEIPT TITLE -->
        <div style="text-align: center; background: #103f7a; color: #ffffff; font-size: 13px; font-weight: bold; padding: 4px 0; margin: 5px 10px 15px 10px; letter-spacing: 3px; border-radius: 2px;">
          ${titleText}
        </div>

        <!-- BILL METADATA GRID INFO BAR -->
        <div style="margin: 0 10px 15px 10px; border: 1px solid #cbd5e1; border-radius: 3px; overflow: hidden; background: #fdfdfd;">
          <table style="width: 100%; border-collapse: collapse; font-size: 11px; font-family: 'Times New Roman', Times, serif;">
            <tr>
              <td style="padding: 10px 12px; border-right: 1px solid #cbd5e1; border-bottom: 1px solid #cbd5e1;">
                <span style="font-weight: bold; color: #525252;">${refLabel}:</span> <span style="color: #000000;">${item.ref_no}</span>
              </td>
              <td style="padding: 10px 12px; border-right: 1px solid #cbd5e1; border-bottom: 1px solid #cbd5e1;">
                <span style="font-weight: bold; color: #525252;">Date:</span> <span style="color: #000000;">${item.date ? new Date(item.date).toLocaleDateString('en-IN') : formattedDate}</span>
              </td>
              <td style="padding: 10px 12px; border-right: 1px solid #cbd5e1; border-bottom: 1px solid #cbd5e1;">
                <span style="font-weight: bold; color: #525252;">Party Name:</span> <span style="color: #000000; font-weight: bold;">${item.party}</span>
              </td>
              <td style="padding: 10px 12px; border-bottom: 1px solid #cbd5e1;">
                <span style="font-weight: bold; color: #525252;">Mobile:</span> <span style="color: #000000;">${item.mobile_no || 'N/A'}</span>
              </td>
            </tr>
            <tr>
              <td colspan="4" style="padding: 6px 12px; font-size: 10.5px; text-align: right; color: #64748b; background: #ffffff;">
                Print Date: <span style="font-weight: bold; color: #334155;">${formattedDate}</span>
              </td>
            </tr>
          </table>
        </div>

        <!-- CONTENT LAYOUT SECTION -->
        <div style="padding: 5px 10px 15px 10px; position: relative;">
          <!-- Watermark Logo Style -->
          <div style="position: absolute; top: 45%; left: 50%; transform: translate(-50%, -50%) rotate(-12deg); width: 30%; opacity: 0.03; pointer-events: none; z-index: 0;">
            <img src="${logoSrc}" style="width: 100%; height: auto;" />
          </div>

          <!-- ITEMS AND VALUES ACCOUNTING TABLE -->
          <table style="width:100%; border-collapse: collapse; font-size: 11.5px; font-family: 'Times New Roman', Times, serif; border: 1px solid #a3a3a3; margin-bottom: 15px; position: relative; z-index: 1;">
            <thead>
              <tr style="background: #103f7a; color: #ffffff; font-weight: bold;">
                <th style="padding: 8px; text-align: center; width: 8%; border-right: 1px solid #cbd5e1; font-size: 11px;">#</th>
                <th style="padding: 8px; text-align: left; width: 22%; border-right: 1px solid #cbd5e1; font-size: 11px;">VEHICLE NO</th>
                <th style="padding: 8px; text-align: left; width: 40%; border-right: 1px solid #cbd5e1; font-size: 11px;">DESCRIPTION</th>
                <th style="padding: 8px; text-align: center; width: 15%; border-right: 1px solid #cbd5e1; font-size: 11px;">SERVICE DATE</th>
                <th style="padding: 8px; text-align: right; width: 15%; font-size: 11px;">AMOUNT (₹)</th>
              </tr>
            </thead>
            <tbody>
              ${itemsRows}
              <!-- Final Total Calculation Display -->
              <tr style="background: #fbfbfb; border-top: 1.5px solid #a3a3a3; font-weight: bold;">
                <td style="padding: 10px; text-align: right; font-size: 11.5px; color: #103f7a; border-right: 1px solid #cbd5e1;" colspan="3">TOTAL SUM AMOUNT</td>
                <td style="padding: 10px; text-align: center; background: #f4f4f5; border-right: 1px solid #cbd5e1; color: #334155; font-size: 10.5px;">INR</td>
                <td style="padding: 10px; text-align: right; font-size: 13.5px; color: #103f7a; background: #f0f7ff;">${formatCurrency(totalAmount)}</td>
              </tr>
            </tbody>
          </table>

          <!-- SUB-PAYMENT CONDITIONAL BLOCK -->
          <div style="position: relative; z-index: 1;">
            ${paymentSectionHtml}
          </div>

          <!-- BANK ACCOUNT CREDENTIALS BLOCK -->
          <div style="margin: 15px 0 20px 0; padding: 10px 12px; background: #f7faff; border-left: 4px solid #103f7a; border-radius: 3px; font-size: 11px; display: flex; flex-wrap: wrap; justify-content: space-between; gap: 15px; border-top: 1px solid #e0f2fe; border-right: 1px solid #e0f2fe; border-bottom: 1px solid #e0f2fe;">
            <div><strong style="color: #103f7a;">🏦 A/C NO:</strong> <span style="font-weight: bold;">38473468220</span></div>
            <div><strong style="color: #103f7a;">🏛️ IFSC:</strong> <span style="font-weight: bold;">SBIN0002852</span></div>
            <div><strong style="color: #103f7a;">👤 NAME:</strong> <span style="text-transform: uppercase;">Durgesh Kumar Siware</span></div>
            <div><strong style="color: #103f7a;">📞 MO:</strong> <span>7974997280, 7389042205</span></div>
          </div>

          <!-- DIGITAL SIGNATURE REGION -->
          <div style="display: flex; justify-content: space-between; margin: 35px 15px 10px 15px; font-size: 11px;">
            <div style="text-align: center; width: 30%;">
              <div style="border-bottom: 1px solid #cbd5e1; height: 35px; margin-bottom: 5px;"></div>
              <div style="color: #4b5563;">Customer Signature</div>
            </div>
            <div style="text-align: center; width: 30%;">
              <div style="font-weight: bold; color: #103f7a; margin-bottom: 20px; font-size: 11.5px;">Durgesh Siware</div>
              <div style="border-top: 1px solid #cbd5e1; padding-top: 5px; color: #4b5563;">Authorized Signature</div>
            </div>
          </div>
        </div>

        <!-- SYSTEM COMPACT FOOTER OVERLAY -->
        <div style="background:#0d1e3d; width:100%; border-radius: 2px; overflow: hidden; margin-top: 5px; font-family: Arial, Helvetica, sans-serif;">
          <div style="background:#103f7a; padding:8px 15px; display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:10px;">
            <div style="font-size:8.5px; font-weight:bold; color:#ffffff; letter-spacing: 0.3px;">📍 Near Babla Fuels, Piyush Seat Cover Road, Parking No. 1, Transport Nagar, Raipur (C.G.) 493221</div>
            <div style="background:#1c7c34; padding:3px 12px; border-radius:12px; font-size:8.5px; font-weight:bold; color:#ffffff;">✉ durgeshshivare@gmail.com</div>
          </div>
          <div style="background:#ffffff; padding:5px 15px; display:flex; justify-content:flex-end; gap:15px; align-items: center;">
            <svg style="height:16px;" viewBox="0 0 100 40" xmlns="http://www.w3.org/2000/svg"><rect width="100" height="40" rx="3" fill="#0f4c81"/><circle cx="20" cy="20" r="10" fill="white" opacity="0.2"/><text x="60" y="21" font-family="sans-serif" font-weight="bold" font-size="7" fill="white" text-anchor="middle">UNITED INDIA</text><text x="60" y="30" font-family="sans-serif" font-size="5.5" fill="#cbd5e1" text-anchor="middle">INSURANCE</text></svg>
            <svg style="height:16px;" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="17" fill="#103f7a" stroke="#7ac143" stroke-width="1.5"/><path d="M15,12 L18,10 L22,13 L25,11 L28,16 L24,22 L26,28 L20,32 L16,28 L13,24 L16,18 Z" fill="white" opacity="0.85"/></svg>
          </div>
          <div style="background:#051429; padding:6px 15px; text-align:center;">
            <div style="display:flex; flex-wrap:wrap; justify-content:center; gap:3px 12px; font-weight: normal;">
              <span style="font-size:8px; color:#cbd5e1;">ड्राइविंग लाइसेंस</span>
              <span style="font-size:8px; color:#cbd5e1;">इंश्योरेंस</span>
              <span style="font-size:8px; color:#cbd5e1;">रोड टैक्स</span>
              <span style="font-size:8px; color:#cbd5e1;">परमिट</span>
              <span style="font-size:8px; color:#cbd5e1;">नाम ट्रांसफर</span>
              <span style="font-size:8px; color:#cbd5e1;">HSRP नं. प्लेट</span>
              <span style="font-size:8px; color:#cbd5e1;">फिटनेस</span>
              <span style="font-size:8px; color:#cbd5e1;">आर.टी.ओ वर्क</span>
            </div>
          </div>
          <div style="font-size:6px; color:#4b5563; text-align:center; padding:3px; background:#020b17; font-weight: bold; letter-spacing: 0.5px;">powered by yashvitech IT solution</div>
        </div>
      </div>
    `;

    // html2pdf Engine Options Configuration
    const opt = {
      margin: [0.3, 0.3, 0.3, 0.3],
      filename: `${item.type || 'Document'}_${item.ref_no || 'Report'}_${new Date().toISOString().slice(0, 10)}.pdf`,
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 2, useCORS: true, logging: false, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    };

    // Background engine trigger for seamless auto download
    html2pdf().set(opt).from(element).save().then(() => {
      message.success('PDF downloaded successfully!');
    }).catch((error) => {
      console.error('PDF generation error:', error);
      message.error('Failed to generate PDF');
    });
  };

  const handleViewDetails = (item) => {
    setSelectedTransaction(item);
    setModal({ type: 'view', data: item });
  };

  if (stats.loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Card>
          <DashboardOutlined spin style={{ fontSize: 40, color: '#1890ff' }} />
          <div style={{ marginTop: 16 }}>Loading Dashboard...</div>
        </Card>
      </div>
    );
  }

  const pending = stats.pendingAmount;
  const collectionRate = (stats.collectionRate * 100).toFixed(1);

  // Styled Stat Cards
  const statCards = [
    {
      title: 'Total Bills',
      value: stats.totalBills,
      prefix: '₹',
      icon: <FileTextOutlined style={{ fontSize: 32, color: '#1890ff' }} />,
      color: '#1890ff',
      bg: '#e6f7ff',
      trend: `₹${stats.totalBills.toLocaleString()}`
    },
    {
      title: 'Total Receipts',
      value: stats.totalReceipts,
      prefix: '₹',
      icon: <CheckCircleOutlined style={{ fontSize: 32, color: '#52c41a' }} />,
      color: '#52c41a',
      bg: '#f6ffed',
      trend: `₹${stats.totalReceipts.toLocaleString()}`
    },
    {
      title: 'Pending Amount',
      value: pending,
      prefix: '₹',
      icon: <WalletOutlined style={{ fontSize: 32, color: '#ff4d4f' }} />,
      color: '#ff4d4f',
      bg: '#fff1f0',
      trend: pending > 0 ? 'Due' : 'Paid'
    },
    {
      title: 'Collection Rate',
      value: collectionRate,
      suffix: '%',
      icon: <RiseOutlined style={{ fontSize: 32, color: '#fa8c16' }} />,
      color: '#fa8c16',
      bg: '#fff7e6',
      trend: `${collectionRate}% Collected`
    },
    {
      title: 'Total Vehicles',
      value: stats.totalVehicles,
      icon: <TruckOutlined style={{ fontSize: 32, color: '#722ed1' }} />,
      color: '#722ed1',
      bg: '#f9f0ff',
      trend: 'Active Vehicles'
    },
    {
      title: 'Total Receipts',
      value: stats.totalTransactions,
      icon: <ReconciliationOutlined style={{ fontSize: 32, color: '#13c2c2' }} />,
      color: '#13c2c2',
      bg: '#e6fffa',
      trend: 'Total Receipts'
    }
  ];

  return (
    <div style={{ minHeight: '100vh' }}>
      {/* Stats Cards */}
      <Row gutter={[16, 16]}>
        {statCards.map((card, index) => {
          const colors = [
            "#1677ff",
            "#52c41a",
            "#ff4d4f",
            "#fa8c16",
            "#722ed1",
            "#13c2c2"
          ];

          const gradients = [
            "linear-gradient(135deg,#1677ff,#69b1ff)",
            "linear-gradient(135deg,#52c41a,#95de64)",
            "linear-gradient(135deg,#ff4d4f,#ff7875)",
            "linear-gradient(135deg,#fa8c16,#ffd666)",
            "linear-gradient(135deg,#722ed1,#b37feb)",
            "linear-gradient(135deg,#13c2c2,#87e8de)"
          ];

          return (
            <Col xs={24} sm={12} md={12} lg={8} xl={8} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 25 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.4,
                  delay: index * 0.1
                }}
                whileHover={{
                  y: -4
                }}
                style={{
                  borderRadius: "16px",
                  overflow: "hidden",
                  position: "relative",
                  background: "#fff",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.06)",
                  minHeight: "140px"
                }}
              >
                <div
                  style={{
                    height: "5px",
                    background: gradients[index]
                  }}
                />

                <div style={{ padding: "16px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#8c8c8c",
                          textTransform: "uppercase"
                        }}
                      >
                        {card.title}
                      </div>

                      <div
                        style={{
                          marginTop: 8,
                          fontSize: screens.xs ? 22 : 28,
                          fontWeight: 800,
                          color: colors[index]
                        }}
                      >
                        {card.prefix}
                        {Number(card.value).toLocaleString("en-IN")}
                        {card.suffix}
                      </div>
                    </div>

                    <div
                      style={{
                        width: 52,
                        height: 52,
                        borderRadius: "14px",
                        background: gradients[index],
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                      }}
                    >
                      {React.cloneElement(card.icon, {
                        style: {
                          fontSize: 24,
                          color: "#fff"
                        }
                      })}
                    </div>
                  </div>

                  <div
                    style={{
                      marginTop: 14,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#595959"
                      }}
                    >
                      <ArrowUpOutlined style={{ color: colors[index] }} />
                      {card.trend}
                    </div>

                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        color: colors[index]
                      }}
                    >
                      LIVE
                    </div>
                  </div>
                </div>
              </motion.div>
            </Col>
          );
        })}
      </Row>

      {/* Transactions Section */}
      <Card
        style={{ marginTop: 24, borderRadius: 12, overflow: 'hidden' }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ padding: screens.xs ? '12px' : '16px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
          <Row justify="space-between" align="middle" wrap>
            <Col>
              <Text strong style={{ fontSize: 16, color: '#1890ff' }}>
                {activeView === 'last5' && '📋 Last 5 Transactions'}
                {activeView === 'bills' && '💰 All Bills'}
                {activeView === 'receipts' && '✅ Last 5 Receipts'}
              </Text>
            </Col>
            <Col>
              <Space wrap style={{ justifyContent: screens.xs ? 'center' : 'flex-end' }}>
                <Segmented
                  value={activeView}
                  onChange={(val) => {
                    setActiveView(val);
                    setMobilePage(1);
                  }}
                  options={[
                    { label: 'Last 5 Transactions', value: 'last5' },
                    { label: 'All Pendings Bills', value: 'bills' },
                    { label: 'Last 5 Receipts', value: 'receipts' }
                  ]}
                  size={screens.xs ? 'small' : 'middle'}
                />

                <Input
                  placeholder="Search..."
                  prefix={<SearchOutlined />}
                  onChange={e => {
                    setSearchTerm(e.target.value);
                    setMobilePage(1);
                  }}
                  style={{ width: screens.xs ? 150 : 200 }}
                  size={screens.xs ? 'small' : 'middle'}
                  allowClear
                />

                <Button
                  icon={<DownloadOutlined />}
                  onClick={exportExcel}
                  size={screens.xs ? 'small' : 'middle'}
                  type="primary"
                  ghost
                >
                  {!screens.xs && 'Export Excel'}
                </Button>
              </Space>
            </Col>
          </Row>
        </div>

        {isExtraSmall ? (
          // Mobile View: Collapse Cards
          <>
            {paginatedMobileTransactions.length === 0 ? (
              <Empty
                description="No transactions found"
                style={{ padding: screens.xs ? 40 : 80 }}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ) : (
              <div style={{ padding: '12px' }}>
                <Collapse
                  accordion={false}
                  expandIcon={({ isActive }) => <RightOutlined rotate={isActive ? 90 : 0} />}
                  expandIconPosition="end"
                  style={{ background: 'transparent', border: 'none' }}
                >
                  {paginatedMobileTransactions.map((transaction, idx) => (
                    <Panel
                      key={transaction.ref_no + idx}
                      header={
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', flexWrap: 'wrap', gap: '8px' }}>
                          <Space direction="vertical" size={0} style={{ flex: 1 }}>
                            <Text strong>{transaction.party}</Text>
                            <Text type="secondary" style={{ fontSize: 12 }}>{transaction.ref_no}</Text>
                          </Space>
                          <Space direction="vertical" size={0} align="end">
                            <Text strong style={{ color: transaction.type === 'Bill' ? '#1890ff' : '#52c41a' }}>
                              ₹{transaction.amt.toLocaleString('en-IN')}
                            </Text>
                            <Badge status={transaction.type === 'Bill' ? 'processing' : 'success'} text={transaction.type} />
                          </Space>
                        </div>
                      }
                      style={{
                        marginBottom: 12,
                        background: '#fff',
                        borderRadius: 8,
                        border: '1px solid #f0f0f0',
                        overflow: 'hidden'
                      }}
                    >
                      <div style={{ padding: '4px 0' }}>
                        <Descriptions column={1} bordered size="small" labelStyle={{ fontWeight: 600 }}>
                          <Descriptions.Item label="Reference No">
                            <Tag color={transaction.type === 'Bill' ? 'blue' : 'green'}>
                              {transaction.ref_no}
                            </Tag>
                          </Descriptions.Item>
                          <Descriptions.Item label="Date">
                            <Space>
                              <CalendarOutlined />
                              <Text>{transaction.date ? new Date(transaction.date).toLocaleDateString() : 'N/A'}</Text>
                            </Space>
                          </Descriptions.Item>
                          <Descriptions.Item label="Mobile No">
                            <Text>{transaction.mobile_no || 'N/A'}</Text>
                          </Descriptions.Item>
                          {transaction.vehicle_no && transaction.vehicle_no !== 'N/A' && (
                            <Descriptions.Item label="Vehicle No">
                              <Text>{transaction.vehicle_no}</Text>
                            </Descriptions.Item>
                          )}
                          {transaction.description && (
                            <Descriptions.Item label="Description">
                              {transaction.description}
                            </Descriptions.Item>
                          )}
                        </Descriptions>
                        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
                          <Button
                            type="link"
                            icon={<EyeOutlined />}
                            onClick={() => handleViewDetails(transaction)}
                          >
                            View Details
                          </Button>
                          <Button
                            type="link"
                            icon={<PrinterOutlined />}
                            onClick={() => handlePrint(transaction)}
                          >
                            Print
                          </Button>
                        </div>
                      </div>
                    </Panel>
                  ))}
                </Collapse>

                {activeView === 'bills' && mobileTransactions.length > mobilePageSize && (
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                    <Pagination
                      current={mobilePage}
                      pageSize={mobilePageSize}
                      total={mobileTransactions.length}
                      onChange={handleMobilePageChange}
                      size="small"
                      showSizeChanger={false}
                    />
                  </div>
                )}
              </div>
            )}
          </>
        ) : (
          // Desktop Table View (unchanged)
          <>
            {Object.keys(filteredData).length === 0 ? (
              <Empty
                description="No transactions found"
                style={{ padding: screens.xs ? 40 : 80 }}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ) : (
              <Table
                size="middle"
                pagination={activeView === 'bills' ? {
                  pageSize: screens.xs ? 5 : 10,
                  showTotal: (total) => `Total ${total} bills`,
                  responsive: true
                } : false}
                dataSource={Object.entries(filteredData).flatMap(([party, items]) =>
                  items.map((item, index) => ({
                    key: `${party}_${item.ref_no}_${index}`,
                    party,
                    item,
                    rowSpan: index === 0 ? items.length : 0
                  }))
                )}
                rowClassName={(_, index) =>
                  index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                }
                columns={[
                  {
                    title: 'Party Name',
                    dataIndex: 'party',
                    key: 'party',
                    width: screens.xs ? 120 : 180,
                    render: (text, row) => ({
                      children: (
                        <Space>
                          <Avatar size="small" style={{ backgroundColor: '#1890ff' }}>
                            {text?.charAt(0) || '?'}
                          </Avatar>
                          <Text strong>{text}</Text>
                        </Space>
                      ),
                      props: { rowSpan: row.rowSpan }
                    })
                  },
                  {
                    title: 'Ref No',
                    key: 'ref_no',
                    width: 100,
                    render: (_, r) => (
                      <Tag color={r.item.type === 'Bill' ? 'blue' : 'green'} style={{ fontWeight: 500 }}>
                        {r.item.ref_no}
                      </Tag>
                    )
                  },
                  {
                    title: 'Type',
                    key: 'type',
                    width: 100,
                    render: (_, r) => (
                      <Badge
                        status={r.item.type === 'Bill' ? 'processing' : 'success'}
                        text={r.item.type}
                      />
                    )
                  },
                  {
                    title: 'Amount',
                    key: 'amount',
                    width: 120,
                    align: 'right',
                    render: (_, r) => (
                      <Text
                        strong
                        style={{
                          color: r.item.type === 'Bill' ? '#1890ff' : '#52c41a',
                          fontSize: screens.xs ? 13 : 14
                        }}
                      >
                        ₹{r.item.amt.toLocaleString('en-IN')}
                      </Text>
                    )
                  },
                  {
                    title: 'Date',
                    key: 'date',
                    width: 110,
                    render: (_, r) => (
                      <Space>
                        <CalendarOutlined style={{ color: '#8c8c8c' }} />
                        <Text>{r.item.date ? new Date(r.item.date).toLocaleDateString() : 'N/A'}</Text>
                      </Space>
                    )
                  },
                  {
                    title: 'Actions',
                    key: 'actions',
                    width: 100,
                    fixed: screens.md ? 'right' : undefined,
                    render: (_, r) => (
                      <Space size="small">
                        <Tooltip title="View Details">
                          <Button
                            type="link"
                            icon={<EyeOutlined />}
                            onClick={() => handleViewDetails(r.item)}
                            size="small"
                          />
                        </Tooltip>
                        <Tooltip title="Print">
                          <Button
                            type="link"
                            icon={<PrinterOutlined />}
                            onClick={() => handlePrint(r.item)}
                            size="small"
                          />
                        </Tooltip>
                      </Space>
                    )
                  }
                ]}
                scroll={{ x: screens.xs ? 700 : undefined }}
              />
            )}
          </>
        )}
      </Card>

      {/* View Modal */}
      <Modal
        open={!!modal && modal.type === 'view'}
        title={
          <Space>
            <EyeOutlined style={{ color: '#1890ff' }} />
            <span>Transaction Details</span>
          </Space>
        }
        onCancel={() => setModal(null)}
        footer={[
          <Button key="print" icon={<PrinterOutlined />} onClick={() => handlePrint(selectedTransaction)}>
            Print
          </Button>,
          <Button key="close" type="primary" onClick={() => setModal(null)}>
            Close
          </Button>
        ]}
        width={500}
      >
        {selectedTransaction && (
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Reference No">
              <Tag color={selectedTransaction.type === 'Bill' ? 'blue' : 'green'}>
                {selectedTransaction.ref_no}
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item label="Party Name">
              <Space>
                <Avatar size="small" style={{ backgroundColor: '#1890ff' }}>
                  {selectedTransaction.party?.charAt(0)}
                </Avatar>
                <Text strong>{selectedTransaction.party}</Text>
              </Space>
            </Descriptions.Item>
            <Descriptions.Item label="Type">
              <Badge
                status={selectedTransaction.type === 'Bill' ? 'processing' : 'success'}
                text={selectedTransaction.type}
              />
            </Descriptions.Item>
            <Descriptions.Item label="Amount">
              <Text style={{ fontSize: 18, fontWeight: 'bold', color: selectedTransaction.type === 'Bill' ? '#1890ff' : '#52c41a' }}>
                ₹{selectedTransaction.amt.toLocaleString('en-IN')}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item label="Date">
              <Space>
                <CalendarOutlined />
                <Text>{selectedTransaction.date ? new Date(selectedTransaction.date).toLocaleDateString() : 'N/A'}</Text>
              </Space>
            </Descriptions.Item>
            <Descriptions.Item label="Mobile No">
              <Text>{selectedTransaction.mobile_no || 'N/A'}</Text>
            </Descriptions.Item>
            {selectedTransaction.description && (
              <Descriptions.Item label="Description">
                {selectedTransaction.description}
              </Descriptions.Item>
            )}
          </Descriptions>
        )}
      </Modal>

      {/* Custom CSS for table row striping */}
      <style>{`
        .table-row-light {
          background-color: #ffffff;
        }
        .table-row-dark {
          background-color: #fafafa;
        }
        .ant-table-tbody > tr:hover > td {
          background-color: #e6f7ff !important;
        }
      `}</style>
    </div>
  );
};

export default DashboardContent;